import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { RachelFeedbackProblemType } from '../../../../../../../../../../services/modules/rachelChats/rachelChats.types';

interface RachelFeedbackProblemTypeOption {
  value: RachelFeedbackProblemType;
  label: LangEnum;
}

export const RACHEL_FEEDBACK_PROBLEM_TYPES: RachelFeedbackProblemTypeOption[] = [
  { value: 'inaccurate', label: LangEnum.RACHEL_FEEDBACK_PROBLEM_INACCURATE },
  { value: 'not_followed', label: LangEnum.RACHEL_FEEDBACK_PROBLEM_NOT_FOLLOWED },
  { value: 'offensive', label: LangEnum.RACHEL_FEEDBACK_PROBLEM_OFFENSIVE },
  { value: 'other', label: LangEnum.RACHEL_FEEDBACK_PROBLEM_OTHER },
];
